import { Injectable, signal } from '@angular/core';
import { IDocument } from '../../../interfaces/i-document';
import { SVGIcon, fileWordIcon, filePdfIcon, fileExcelIcon, filePptIcon, fileTxtIcon, html5Icon, dataJsonIcon, fileCsvIcon, fileImageIcon, clipboardHtmlIcon, fileIcon, fileTypescriptIcon, fileProgrammingIcon } from '@progress/kendo-svg-icons';
import { IChatSession } from "../../../interfaces/i-chat-session";

@Injectable({
  providedIn: 'root'
})
export class ChatDocumentService {
  selectedDocuments = signal<IDocument[]>([]);
  constructor() { }

  storeSelectedDocuments(sessionId: string, docs: any[]) {
    const currentDocuments = this.selectedDocuments();

    // Create a new object with the updated documents for the given sessionId
    const updatedDocuments = {
      ...currentDocuments,
      [sessionId]: docs
    };

    // Update the signal with the new documents
    // this.selectedDocuments.set(updatedDocuments);
  }

  getAttachmentIcon(fileName: string): SVGIcon {
    if (fileName.endsWith('.doc') || fileName.endsWith('.docx') || fileName.endsWith('.dotx')) {
      return fileWordIcon;
    } else if (fileName.endsWith('.pdf')) {
      return filePdfIcon;
    } else if (fileName.endsWith('.xls') || fileName.endsWith('.xlsx') || fileName.endsWith('.xltx')) {
      return fileExcelIcon;
    } else if (fileName.endsWith('.ppt') || fileName.endsWith('.pptx') || fileName.endsWith('.potx')) {
      return filePptIcon;
    } else if (fileName.endsWith('.txt') || fileName.endsWith('.md') || fileName.endsWith('.log')) {
      return fileTxtIcon;
    } else if (fileName.endsWith('.html')) {
      return html5Icon;
    } else if (fileName.endsWith('.json')) {
      return dataJsonIcon;
    } else if (fileName.endsWith('.csv')) {
      return fileCsvIcon;
    } else if (fileName.endsWith('.ts') || fileName.endsWith('.tsx')) {
      return fileTypescriptIcon;
    }else if (fileName.endsWith('.png') || fileName.endsWith('.jpg') || fileName.endsWith('.jpeg') || fileName.endsWith('.webp') || fileName.endsWith('.gif') || fileName.endsWith('.svg')) {
      return fileImageIcon;
    } else if (fileName.endsWith('.xml')
      || fileName.endsWith('.cs')
      || fileName.endsWith('.css')
      || fileName.endsWith('.scss')
      || fileName.endsWith('.js')
      || fileName.endsWith('.jsx')
      || fileName.endsWith('.vue')
      || fileName.endsWith('.py')
      || fileName.endsWith('.java')
      || fileName.endsWith('.jsp')
      || fileName.endsWith('.yaml')
      || fileName.endsWith('.yml')
      || fileName.endsWith('.sql')
      || fileName.endsWith('.sass')) {
      return fileProgrammingIcon;
    } else {
      return fileIcon;
    }
  }

  /**
   * Extracts all documents from the messages in a chat session.
   */
  getAllDocumentsInTheSession(session: IChatSession): IDocument[] {
    if (!session || !session.messages) {
      return [];
    }

    return session.messages
      .filter(message => message.meta && message.meta.documents) // Filter messages with documents
      .flatMap(message => message.meta!.documents as IDocument[]); // Map to IDocument[]
  }
}
